import React from "react";
import { AppRoutes } from "../../constants/routes";
import BaseErrorNotification from "components/notifications/BaseErrorNotification";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const DocuSignProcessFailedNotification = ({ events }) => {
  const { t } = useTranslation("system");
  return (
    <BaseErrorNotification
      content={
        <p>
          {t("DocuSign_Process_Failed_Notification")} {t("please_view")}{" "}
          <Link to={AppRoutes.Notification} className="ui link">
            Notifications page
          </Link>{" "}
          {t("for_more_details")}
        </p>
      }
      events={events}
    />
  );
};

export default DocuSignProcessFailedNotification;
